export default __webpack_public_path__ + "static/media/HN.909ca1fb.jfif";